export const contactsData = {
    email: 'pkalmuczak@gmail.com',
    phone: '+48 725 428 579',
    address: 'Gliniana Street, Wroclaw, Poland',

    sheetAPI: ''
}